module.exports = __webpack_public_path__ + "static/media/1.1 Nachtlandschaft OfR klein.75e86dfa.jpg";